import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import multiMonthPlugin from '@fullcalendar/multimonth';
import listPlugin from '@fullcalendar/list';
import { useTranslation } from 'react-i18next';
import AddEventModal from './AddEventModal';
import './calendar.css';
import ExternalEventPopover from './ExternalEventPopover';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { GetAccountEmployeeTimeEntryCustomFields, getCalendarEvents, GetGoogleCalendarEvents, getIntegrations, GetOutlookCalendarEvents, GetTimeoffCalendarEvents, gettimesheetData, gettimesheetRecord, updateCustomFieldFalg, updateDateOfCalendar, UpdateEventCalendar, updateEventFalg } from './CalendarSlice';
import moment from 'moment';
import CalendarSettings from './CalendarSettings';
import Loader from '../../common/Loader';
import InternalEventPopover from './InternalEventPopover';
import UpdateInternalEvent from './UpdateInternalEvent';
import { ShowToast } from '../../common/Toastr';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { getAccountFeatureAsync, GetCalendarEventsForNotification, getPagePermissionsAsync } from '../../common/GlobalSlice';
import { formatDateWithDateAndMonthName, getValueFromResource } from '../../common/timeLiveFunction';
import ReminderToast from './ReminderToast';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EventLegendsPopup from './EventLegendsPopup';
import { useLocation, useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '../../_metronic/helpers';

interface PagePermissions {
    IsAdd: boolean;
    IsDelete: boolean;
    IsEdit: boolean;
    IsList: boolean;
}

const Calendar = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isOpenCalendarSettings, setIsOpenCalendarSettings] = useState(false);
    const [dayTotals, setDayTotals] = useState<{ [date: string]: string }>({});
    const { loading } = useAppSelector((state) => state.calendar);
    const { calendarStartDay, cultureInfoName, accountFeatureList, pageId, menuList, showClientInTimesheet, showCostCenterInTimeSheet, showWorkTypeInTimeSheet } = useAppSelector((state) => state.globalState);
    const [clickedDate, setClickedDate] = useState<Date | null>(null);
    const [currentView, setCurrentView] = useState<string>('dayGridMonth');
    const [selectedEvent, setSelectedEvent] = useState<any>(null);
    const modelRef = useRef<any>(null);
    const calendarRef = useRef<any>(null);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { integrationValue, googleEvents, outlookEvents, googleConnected, outlookConnected, googleHolidayEvents, outlookHolidayEvents, GoogleColorCode, OutlookColorCode, reloader } = useAppSelector((state) => state.calendar);
    const { isUpdateData } = useAppSelector((state) => state.featureManagement);
    const [showTimesheet, setShowTimesheet] = useState<boolean>(false);
    const [showTimeoff, setShowTimeoff] = useState<boolean>(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const AccountId = localStorage.getItem('accountId');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const [calendarEvents, setCalendarEvents] = useState<any[]>([]);
    const [popoverPosition, setPopoverPosition] = useState<{ top: number, left: number } | null>(null);
    const [internalPopoverPosition, setInternalPopoverPosition] = useState<{ top: number, left: number } | null>(null);
    const [popoverEvent, setPopoverEvent] = useState<any>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isAddEvent, setIsAddEvent] = useState(false);
    const [timeoffEvent, setTimeoffEvent] = useState([]);
    const [timesheetEvents, setTimesheetEvents] = useState([]);
    const [presetStartTime, setPresetStartTime] = useState('');
    const [presetEndTime, setPresetEndTime] = useState('');
    const [isShow, setisShow] = useState(false);
    const [showLegends, setShowLegends] = useState(false);
    const [permissions, setPermissions] = useState<PagePermissions | null>(null);
    const [legendsButtonRef, setLegendsButtonRef] = useState<HTMLElement | null>(null);
    const currentDate = moment().format('YYYY-MM-DD');
    document.title = `Calendar | Livetecs`;
    // const showTimesheet = accountFeatureList?.some((item: any) => item?.Id === 'db17deb7-51a0-4400-bf3b-9094e01ef038') ?? false;
    // const showTimeoff = accountFeatureList?.some((item: any) => item?.Id === '76aaf57e-96a4-4476-94a4-575824e9b9fa') ?? false;
    const eventSources = useMemo(() => [
        {
            events: calendarEvents,
            id: 'internal',
            className: 'internal-event',
            editable: true,
        },
        {
            events: googleEvents?.length > 0 ? googleEvents : [],
            id: 'google',
            className: 'enternal-event',
            editable: false,
        },
        {
            events: outlookEvents?.length > 0 ? outlookEvents : [],
            id: 'outlook',
            className: 'outlook-event',
            editable: false,
        },
        {
            id: 'staticEvents',
            events: showTimeoff ? timeoffEvent : [],
            className: 'All-Day-event',
            editable: false,
        },
        {
            id: 'googleHolidays',
            events: googleHolidayEvents,
            className: 'enternal-event',
            editable: false,
            allDay: true
        },
        {
            id: 'outlookHolidays',
            events: outlookHolidayEvents,
            className: 'outlook-event',
            editable: false,
            allDay: true
        },
        {
            id: 'timeEntry',
            events: showTimesheet ? timesheetEvents : [],
            className: 'timeEntry-event',
            editable: false
        }
    ], [calendarEvents, googleEvents, outlookEvents, timeoffEvent, googleHolidayEvents, outlookHolidayEvents, timesheetEvents, showTimesheet, showTimeoff])
    useEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                setPermissions(res.payload);
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                console.log(pageId,routeName,foundItem, "pageId")
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        }
        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const closeModal = () => {
        setisShow(false);
        setClickedDate(null);
    };

    const closeAddEventModal = () => {
        setIsAddEvent(false);
        setClickedDate(null);
    };

    const closeSettingsModal = () => {
        setIsOpenCalendarSettings(false);
    };
    useEffect(() => {
        dispatch(getAccountFeatureAsync()).then((res: any) => {
            const result = res?.payload?.AccountFeatures;
            const isCalendar = result?.some((item: any) => item?.SystemFeatureId === '9289f75c-48be-4002-bef6-df8be6e014cb');
            if (!isCalendar) {
                navigate('../error/403');
                return;
            }
            if (result?.length > 0) {
                setShowTimesheet(result?.some((item: any) => item?.SystemFeatureId === 'db17deb7-51a0-4400-bf3b-9094e01ef038') ?? false);
                setShowTimeoff(result?.some((item: any) => item?.SystemFeatureId === '76aaf57e-96a4-4476-94a4-575824e9b9fa') ?? false);
            }
        })
    }, [isUpdateData]);

    useEffect(() => {
        const btn = document.querySelector('.fc-settingsButton-button') as HTMLElement;
        if (btn) {
            btn.innerHTML = `
            <span 
                data-tooltip-id="tooltip-TimeEntry"  
                data-tooltip-content="${getValueFromResource('Calendar Settings', dispatch, t)}"
                style="display: flex; align-items: center; justify-content: center;"
            >
                <img src="${toAbsoluteUrl('/media/svg/features-logos/Calander-Icon.svg')}" alt="Settings" width="17" height="17" />
            </span>
        `;
            //     btn.innerHTML = `<i class="ki-duotone ki-technology-4 fs-1 text-gray-600 mt-1" 
            //     data-tooltip-id="tooltip-TimeEntry"  
            //     data-tooltip-content="${getValueFromResource('Calendar Settings', dispatch, t)}">
            //     <span class="path1"></span>
            //     <span class="path2"></span>
            // </i>`;
        }

        const legendBtn = document.querySelector('.fc-legendsButton-button') as HTMLElement;
        if (legendBtn) {
            legendBtn.innerHTML = `<span style="
            color: gray;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;
            padding: 4px 8px;
            border-radius: 4px;
        ">${getValueFromResource('Event Legends', dispatch, t)} <i id="legend-info-icon" class="bi bi-info-circle" style="cursor:pointer;"></i>
        </span>`;

            setLegendsButtonRef(legendBtn);

            const infoIcon = legendBtn.querySelector('#legend-info-icon') as HTMLElement;
            if (infoIcon) {
                infoIcon.addEventListener('mouseenter', () => {
                    setShowLegends(true);
                });
            }
        }
    }, [dispatch, t]);

    useEffect(() => {
        if (!legendsButtonRef || !showLegends) return;

        const handleMouseLeave = (e: MouseEvent) => {
            const legendsPopup = document.querySelector('.event-legends-popup');
            const relatedTarget = e.relatedTarget as HTMLElement;
            if (legendsPopup && legendsPopup.contains(relatedTarget)) {
                return;
            }

            setTimeout(() => {
                const isHoveringButton = legendsButtonRef.contains(document.elementFromPoint(e.clientX, e.clientY) as Node);
                const isHoveringPopup = legendsPopup && legendsPopup.contains(document.elementFromPoint(e.clientX, e.clientY) as Node);

                if (!isHoveringButton && !isHoveringPopup) {
                    setShowLegends(false);
                }
            }, 100);
        };

        legendsButtonRef.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            legendsButtonRef.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [legendsButtonRef, showLegends]);

    useEffect(() => {
        dispatch(getIntegrations());
        dispatch(updateDateOfCalendar({ calendarStartDate: startDate, calendarEndDate: endDate }))
    }, [dispatch, startDate, endDate]);

    useEffect(() => {
        if (!startDate || !endDate) return;
        if (!integrationValue?.length) return;

        const payload = { StartDate: startDate, EndDate: endDate };

        if (integrationValue.includes('3b00775f-9b50-4a7d-926f-1192e2e3033e') && googleConnected?.InBound === true) {
            dispatch(GetGoogleCalendarEvents(payload));
        }

        if (integrationValue.includes('6e0e6a9c-7a37-4bda-8d6a-d7d61f00b828') && outlookConnected?.InBound === true) {
            dispatch(GetOutlookCalendarEvents(payload));
        }

    }, [dispatch, startDate, endDate, integrationValue, googleConnected, outlookConnected]);

    useEffect(() => {
        const payload = {
            StartDate: startDate,
            EndDate: endDate,
            AccountEmployeeId: AccountEmployeeId
        }
        if (startDate && endDate && AccountEmployeeId) {
            dispatch(getCalendarEvents(payload))
                .unwrap()
                .then((res) => {
                    if (res?.length > 0) {
                        const eventsList = res?.map((item: any) => ({
                            id: item.CalendarEventId,
                            title: item.EventName,
                            start: item.StartTime,
                            end: item.EndTime,
                            // url: null,
                            extendedProps: {
                                type: 'internal',
                                Description: item.Description,
                                SystemReminderTimeId: item.SystemReminderTimeId,
                                StartTimeZoneId: item?.StartTimeZoneId,
                                EndTimeZoneId: item?.EndTimeZoneId,
                                StartTimeZone: '',
                                EndTimeZone: ''
                            },
                        }))
                        setCalendarEvents(eventsList);
                        dispatch(updateEventFalg(false));
                    } else {
                        setCalendarEvents([]);
                    }
                })
                .catch((error) => {
                    console.log(error)
                    ShowToast('error', error, "error", "toast-top-right");
                })
        }

    }, [dispatch, startDate, endDate, AccountEmployeeId, loading])

    useEffect(() => {
        const payload = {
            StartDate: startDate,
            EndDate: endDate,
            AccountEmployeeId: AccountEmployeeId
        }
        if (startDate && endDate && AccountEmployeeId && showTimeoff) {
            dispatch(GetTimeoffCalendarEvents(payload))
                .unwrap()
                .then((res) => {
                    if (res?.length > 0) {
                        const timeoffEventsList = res?.map((item: any) => ({
                            id: item?.TimeOffTypeId,
                            title: item.TimeOffTypeName,
                            start: item.StartDate,
                            end: item.EndDate,
                            allDay: true,
                            className: 'All-Day-event',
                            editable: false,
                            extendedProps: {
                                type: 'AllDayEvent',
                            },
                        }))
                        setTimeoffEvent(timeoffEventsList);
                        dispatch(updateEventFalg(false));
                    } else {
                        setTimeoffEvent([]);
                    }
                })
                .catch((error) => {
                    ShowToast('error', error, "error", "toast-top-right");
                })
        }
    }, [dispatch, startDate, endDate, AccountEmployeeId, loading, showTimeoff])

    useEffect(() => {
        if (startDate && endDate && AccountEmployeeId && showTimesheet) {
            dispatch(gettimesheetRecord({ AccountEmployeeId, startDate, endDate }))
                .unwrap()
                .then((res) => {
                    if (res?.length > 0) {
                        const timeEntryResult = res?.map((item: any) => {
                            let start: Date | string = item?.StartTime;
                            let end: Date | string = item?.EndTime;

                            if (!start || !end) {
                                const baseDate = new Date(item?.TimeEntryDate);
                                baseDate.setHours(9, 0, 0, 0);
                                start = new Date(baseDate);
                                const endDate = new Date(baseDate);
                                endDate.setHours(endDate.getHours() + (item?.Hours || 0));
                                end = endDate;
                            } else {
                                start = new Date(item?.StartTime);
                                end = new Date(item?.EndTime);
                            }

                            const titleParts: string[] = [];
                            if (showClientInTimesheet && item?.ClientName) titleParts.push(item.ClientName);
                            if (item?.ProjectName) titleParts.push(item.ProjectName);
                            if (item?.TaskName) titleParts.push(item.TaskName);
                            if (showCostCenterInTimeSheet && item?.AccountCostCenter) titleParts.push(item.AccountCostCenter);
                            if (showWorkTypeInTimeSheet && item?.AccountWorkType) titleParts.push(item.AccountWorkType);

                        const eventTitle = titleParts.length > 0 ? titleParts.join(' - ') : (item?.ProjectName || item?.ClientName || '');
                            return ({
                                id: item?.AccountEmployeeTimeEntryId?.toString() || crypto.randomUUID(),
                                title: eventTitle,//`${item?.ClientName} - ${item?.ProjectName}`,
                                start: start,
                                end: end,
                                // url: undefined,
                                extendedProps: {
                                    type: 'timeEntry',
                                    Description: item.Description,
                                    ProjectName: item?.ProjectName,
                                    AccountEmployeeTimeEntryApprovalProjectId: item?.AccountEmployeeTimeEntryApprovalProjectId,
                                    AccountEmployeeTimeEntryId: item?.AccountEmployeeTimeEntryId,
                                    TimeEntryDate: item?.TimeEntryDate,
                                    TotalTime: item?.TotalTime,
                                    ClientName: item?.ClientName,
                                    AccountClientId: item?.AccountClientId,
                                    AccountProjectId: item?.AccountProjectId,
                                    ProjectCode: item?.ProjectCode,
                                    AccountProjectTaskId: item?.AccountProjectTaskId,
                                    TaskName: item?.TaskName,
                                    TaskCode: item?.TaskCode,
                                    AccountCostCenterId: item?.AccountCostCenterId,
                                    AccountCostCenter: item?.AccountCostCenter,
                                    AccountCostCenterCode: item?.AccountCostCenterCode,
                                    AccountWorkTypeId: item?.AccountWorkTypeId,
                                    AccountWorkType: item?.AccountWorkType,
                                    AccountWorkTypeCode: item?.AccountWorkTypeCode,
                                    Hours: item?.Hours,
                                    Submitted: item?.Submitted,
                                    Approved: item?.Approved,
                                    AccountId: item?.AccountId,
                                    AccountEmployeeId: item?.AccountEmployeeId,
                                    AccountEmployeeTimeEntryPeriodId: item?.AccountEmployeeTimeEntryPeriodId,
                                    CustomField1: item?.CustomField1 ?? '',
                                    CustomField2: item?.CustomField2 ?? '',
                                    CustomField3: item?.CustomField3 ?? '',
                                    CustomField4: item?.CustomField4 ?? '',
                                    CustomField5: item?.CustomField5 ?? '',
                                    CustomField6: item?.CustomField6 ?? '',
                                    CustomField7: item?.CustomField7 ?? '',
                                    CustomField8: item?.CustomField8 ?? '',
                                    CustomField9: item?.CustomField9 ?? ''
                                },
                            })
                        })
                        setTimesheetEvents(timeEntryResult);
                    } else {
                        setTimesheetEvents([]);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    ShowToast('error', err, "error", "toast-top-right");
                })
        }
    }, [dispatch, startDate, endDate, AccountEmployeeId, loading, showTimesheet])

    useEffect(() => {
        const handleClickOutside = () => {
            // setPopoverEvent(null);
            // setPopoverPosition(null);
            if (popoverEvent) {
                setPopoverEvent(null);
                setPopoverPosition(null);
                setIsOpen(false);
            }

            if (isModalOpen) {
                setInternalPopoverPosition(null);
                setIsModalOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [popoverEvent, isModalOpen]);

    const renderDateSet = (arg: any) => {
        if (!arg.start || !arg.end) return;
        const start = new Date(arg.start);
        const end = new Date(arg.end);
        const formatDate = (date: Date) =>
            date.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric',
            });

        const range = `${formatDate(start)} – ${formatDate(new Date(end.getTime() - 1))}`;
    }

    const handleDragEvent = async (info: any) => {
        if (info.event.extendedProps?.type !== "internal") return;

        try {
            await dispatch(UpdateEventCalendar({
                CalendarEventId: Number(info.event.id),
                AccountId,
                AccountEmployeeId,
                EventName: info?.event?.title,
                Description: info?.event?.extendedProps?.Description,
                StartTime: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss'),
                EndTime: moment(info.event.end).format('YYYY-MM-DDTHH:mm:ss'),
                EventDate: moment(info.event.start).format('YYYY-MM-DD'),
                StartDate: moment(info.event.start).format('YYYY-MM-DD'),
                EndDate: moment(info.event.end).format('YYYY-MM-DD'),
                StartTimeZoneId: info.event.extendedProps?.StartTimeZoneId,
                EndTimeZoneId: info.event.extendedProps?.EndTimeZoneId,
                SystemReminderTimeId: info.event.extendedProps?.SystemReminderTimeId,
                SystemReminderTypeId: 2,
            })).unwrap();
            dispatch(updateEventFalg(true));
            dispatch(GetCalendarEventsForNotification(currentDate));
        } catch (error) {
            console.error('Error updating event:', error);
            ShowToast('Error', error, "error", "toast-top-right");
        }
    };

    const handleEventResize = async (info: any) => {
        if (info.event.extendedProps?.type !== "internal") return;

        try {
            await dispatch(UpdateEventCalendar({
                CalendarEventId: Number(info.event.id),
                AccountId,
                AccountEmployeeId,
                EventName: info?.event?.title,
                Description: info?.event?.extendedProps?.Description,
                StartTime: moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss'),
                EndTime: moment(info.event.end).format('YYYY-MM-DDTHH:mm:ss'),
                EventDate: moment(info.event.start).format('YYYY-MM-DD'),
                StartDate: moment(info.event.start).format('YYYY-MM-DD'),
                EndDate: moment(info.event.end).format('YYYY-MM-DD'),
                StartTimeZoneId: info.event.extendedProps?.StartTimeZoneId,
                EndTimeZoneId: info.event.extendedProps?.EndTimeZoneId,
                SystemReminderTimeId: info.event.extendedProps?.SystemReminderTimeId,
                SystemReminderTypeId: 2,
            })).unwrap();
            dispatch(updateEventFalg(true));
            dispatch(GetCalendarEventsForNotification(currentDate));
        } catch (error) {
            console.error('Error updating event:', error);
            ShowToast('Error', error, "error", "toast-top-right");
        }
    }

    const renderDayHeaderContent = useCallback((arg: any) => {
        const date = arg.date;
        if (currentView === 'dayGridMonth') {
            return <span>{arg.text}</span>;
        }
        const today = new Date();
        const isToday = date.toDateString() === today.toDateString();
        // const dayNumber = date.getDate()
        const dayNumber = moment(date).format('DD');
        const dayName = date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
        const dateKey = moment(date).format("YYYY-MM-DD");
        const total = dayTotals[dateKey] || "00:00:00";
        const timeStr = "00:00:00";
        return (
            <div className='d-flex gap-2'>
                <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
                    <span style={{
                        display: 'inline-block',
                        backgroundColor: isToday ? 'rgba(12, 102, 228, 0.5)' : 'transparent',
                        borderRadius: '50%',
                        padding: isToday ? '6px 12px' : '',
                        fontWeight: isToday ? 'bold' : 'normal',
                        color: isToday ? '#FFFFFF' : '#000',
                        marginBottom: '4px',
                    }}>
                        {dayNumber}
                    </span>
                </div>
                <div className="mt-2 d-flex flex-column" style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '12px', color: '#555' }}>{dayName}</div>
                    <div style={{ fontSize: '12px', color: '#888' }}>{total}</div>
                </div>
            </div>
        );
    }, [dayTotals, currentView])

    const renderEventContent = useCallback((arg: any) => {
        const isExternal = arg.event.source?.id === 'external';
        const view = currentView.startsWith('list')
        const startTime = moment(arg.event.start).format('hh:mm A');
        const endTime = arg.event.end ? moment(arg.event.end).format('hh:mm A') : '';
        const isWeekView = currentView === 'timeGridWeek';

        return (
            <div
                className={`d-flex flex-column w-100 ${view ? '' : !arg.event.allDay ? (isWeekView ? '' : 'my-2') : 'my-3'} ${isExternal ? 'event-content-external' : 'event-content-internal'}`}
                // className={`d-flex flex-column  ${view ? '' : !arg.event.allDay ? 'my-2' : ' my-3'}  w-100 ${isExternal ? 'event-content-external' : 'event-content-internal'}`}
                style={{ lineHeight: '1.2' }}
            >
                <span className="mb-0 text-black" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '100%' }}>{arg.event.title}</span>
                {!arg.event.allDay && !view && (
                    <small style={{ color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', maxWidth: '100%' }}>
                        {endTime ? `${startTime} - ${endTime}` : startTime}
                    </small>
                )}
            </div>
        );
    }, [currentView])

    const onEventClick = useCallback((info: any) => {
        info.jsEvent.preventDefault();
        info.jsEvent.stopPropagation();
        setIsModalOpen(false);
        setIsOpen(false);
        setPopoverEvent(null);
        setPopoverPosition(null);
        setInternalPopoverPosition(null);
        if (info.event.allDay) return;

        if (info?.event?.extendedProps?.type === 'timeEntry' && !currentView.startsWith('list')) {
            const currentDate = moment(info?.event?.start).format('YYYY-MM-DD');
            const endDate = moment(info?.event?.end).format('YYYY-MM-DD');
            setSelectedEvent(info.event);
            const obj = { AccountEmployeeId, currentDate, endDate }
            dispatch(gettimesheetData(obj))
            dispatch(GetAccountEmployeeTimeEntryCustomFields())
            dispatch(updateCustomFieldFalg(true));
            setisShow(true);
            return;
        }
        if (popoverEvent && popoverEvent.id === info.event.id) {
            return;
        }

        if (currentView.startsWith('list')) {
            return;
        }

        setSelectedEvent(info.event);
        if (info.event.extendedProps?.type === 'external' ||
            info.event.extendedProps?.type === 'google' ||
            info.event.extendedProps?.type === 'outlook') {

            const rect = info.el.getBoundingClientRect();
            const top = rect.top + window.scrollY - 5;
            const left = rect.left + window.scrollX + 30;

            setPopoverPosition({ top, left });
            setPopoverEvent(info.event);
            setIsOpen(true);
            dispatch(updateCustomFieldFalg(false));
            return;
        }
        if (info?.event?.extendedProps?.type === 'internal') {
            const rect = info.el.getBoundingClientRect();
            const top = rect.top + window.scrollY - 5;
            const left = rect.left + window.scrollX + 30;

            setInternalPopoverPosition({ top, left })
            const currentDate = moment(info?.event?.start).format('YYYY-MM-DD');
            // const obj = { AccountEmployeeId, currentDate }
            // dispatch(gettimesheetData(obj))
            dispatch(updateCustomFieldFalg(false));
            setIsModalOpen(true);
            return;
        }

        setIsAddEvent(true)
    }, [currentView, popoverEvent, AccountEmployeeId, dispatch])

    const handleEvents = useCallback((events: any[]) => {
        const totalsByDay: { [date: string]: number } = {};

        events.forEach(event => {
            const start = moment(event.start);
            const end = moment(event.end || event.start);
            const duration = moment.duration(end.diff(start)).asSeconds();

            const dayKey = start.format('YYYY-MM-DD');
            totalsByDay[dayKey] = (totalsByDay[dayKey] || 0) + duration;
        });

        const formatted: { [date: string]: string } = {};
        Object.entries(totalsByDay).forEach(([date, seconds]) => {
            const h = Math.floor(seconds / 3600);
            const m = Math.floor((seconds % 3600) / 60);
            const s = seconds % 60;
            const hh = String(h).padStart(2, '0');
            const mm = String(m).padStart(2, '0');
            const ss = String(s).padStart(2, '0');
            formatted[date] = `${hh}:${mm}:${ss}`;
        });

        setDayTotals(formatted);
    }, []);

    useEffect(() => {
        if (GoogleColorCode || OutlookColorCode) {
            let styleElement = document.getElementById('dynamic-outlook-styles');

            if (!styleElement) {
                styleElement = document.createElement('style');
                styleElement.id = 'dynamic-outlook-styles';
                document.head.appendChild(styleElement);
            }

            styleElement.textContent = `
            .outlook-event {
                background-color: ${OutlookColorCode}2A !important;
                border: none !important;
                border-left: 4px solid ${OutlookColorCode} !important;
                color: black !important;
                border-radius: 4px !important;
                padding: 2px 6px !important;
                font-weight: 500;
            }
            .fc-list-event.outlook-event .fc-list-event-dot {
                border-color: ${OutlookColorCode} !important;
                 background: ${OutlookColorCode} !important;
            }
            .enternal-event {
                background-color: ${GoogleColorCode}2A !important;
                border: none !important;
                border-left: 4px solid ${GoogleColorCode} !important;
                color: black !important;
                border-radius: 4px !important;
                padding: 2px 6px !important;
                font-weight: 500;
             }
             .fc-list-event.enternal-event .fc-list-event-dot {
                border-color: ${GoogleColorCode} !important;
                 background: ${GoogleColorCode} !important;
            }
        `;
        }
    }, [GoogleColorCode, OutlookColorCode]);

    useEffect(() => {
        if (!calendarRef.current) return;
        const recalculateCalendar = () => {
            setTimeout(() => {
                if (calendarRef.current) {
                    const calendarApi = calendarRef.current.getApi();
                    calendarApi.updateSize();
                }
            }, 300);
        };
        const calendarElement = calendarRef.current.elRef.current;
        if (calendarElement) {
            const container = calendarElement.closest('.main-content') ||
                calendarElement.closest('.content') ||
                calendarElement.parentElement;

            if (container && window.ResizeObserver) {
                const resizeObserver = new ResizeObserver(recalculateCalendar);
                resizeObserver.observe(container);

                return () => resizeObserver.disconnect();
            }
        }
    }, [currentView]);

    return (
        <>
            {reloader && <Loader />}
            <div style={{
                maxHeight: '80vh',
                overflowY: (isOpen || isModalOpen) ? 'hidden' : 'auto',
                position: 'relative',
                minWidth: '320px',
                transition: 'all 0.3s ease'
            }}>
                <FullCalendar
                    ref={calendarRef}
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, multiMonthPlugin, listPlugin]}
                    initialView='timeGridWeek'
                    allDayText="Holidays"
                    slotMinTime="00:00:00"
                    slotMaxTime="24:00:00"
                    scrollTime="00:00"
                    // scrollTime={moment().format('HH:mm:ss')}
                    scrollTimeReset={false}
                    firstDay={calendarStartDay ?? 0}
                    timeZone="local"
                    nowIndicator={true}
                    dayMaxEvents={true}
                    aspectRatio={1.35}
                    customButtons={{
                        settingsButton: {
                            text: '',
                            click: () => {
                                setIsOpenCalendarSettings(true);
                            }
                        },
                        legendsButton: {
                            text: '',
                            click: () => {
                                setShowLegends(!showLegends);
                            }
                        }
                    }}
                    headerToolbar={{
                        start: 'prev,title,next',
                        center: '',
                        end: 'legendsButton,settingsButton dayGridMonth,timeGridWeek,timeGridDay,listMonth' //today
                    }}
                    titleFormat={(date: any) => {
                        // const start = new Date(date.start.marker);
                        // const end = new Date(date.end.marker);
                        const start = formatDateWithDateAndMonthName(date.start.marker)
                        const end = formatDateWithDateAndMonthName(date.end.marker)
                        // end.setDate(end.getDate() - 1);

                        const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
                        setStartDate(moment(start).format('YYYY-MM-DD'));
                        setEndDate(moment(end).format('YYYY-MM-DD'));
                        // setStartDate(start);
                        // setEndDate(end);
                        // return `${start.toLocaleDateString('en-US', options)} - ${end.toLocaleDateString('en-US', options)}`;
                        // return `${getStartDate} - ${getEndDate}`
                        return `${start} - ${end}`
                    }}
                    slotLabelFormat={{
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true
                    }}
                    views={{
                        dayGridMonth: {
                            dayMaxEvents: 3,
                        },
                        multiMonthYear: {
                            type: 'multiMonth',
                            duration: { months: 12 },
                            buttonText: 'Year',
                            multiMonthMaxColumns: 3,
                        },
                    }}
                    eventDrop={handleDragEvent}
                    eventResize={handleEventResize}
                    eventSources={eventSources}
                    editable={true}
                    selectable={true}
                    eventOverlap={false}
                    slotEventOverlap={false}
                    allDaySlot={true}
                    eventResizableFromStart={true}
                    droppable={true}
                    eventDisplay="auto"
                    viewDidMount={(args) => {
                        setCurrentView(args.view.type);
                        if (calendarRef.current) {
                            const calendarApi = calendarRef.current.getApi();
                            if (
                                args.view.type === 'timeGridWeek' ||
                                args.view.type === 'timeGridDay' ||
                                args.view.type === 'dayGridMonth'
                            ) {
                                calendarApi.today();
                            }
                        }
                    }}
                    eventDidMount={(info) => {
                        if (info.view.type === 'dayGridMonth' || info.view.type === 'timeGridWeek') {
                            info.el.setAttribute('data-tooltip-id', 'event-data-tooltip');
                            info.el.setAttribute('data-tooltip-content', info.event.title);
                            info.el.style.textAlign = 'left'
                        }
                    }}
                    dayHeaderContent={(arg) => {
                        if (currentView === 'dayGridMonth') {
                            return <span>{arg.text}</span>;
                        }
                        return renderDayHeaderContent(arg);
                    }}
                    eventsSet={handleEvents}
                    datesSet={(arg) => renderDateSet(arg)}
                    eventContent={(arg) => renderEventContent(arg)}
                    dateClick={(info) => {
                        if (info.allDay && info.view.type != 'dayGridMonth') return;
                        setIsOpen(false);
                        setIsModalOpen(false);
                        setPopoverEvent(null);
                        setPopoverPosition(null);
                        setInternalPopoverPosition(null);

                        dispatch(updateCustomFieldFalg(false));
                        setIsAddEvent(true);
                        // const clickedDateTime = new Date(info.dateStr);
                        const clickedDateTime = info.date;
                        setClickedDate(clickedDateTime);
                        const clickedTime = moment(clickedDateTime).format("HH:mm");
                        const endTime = moment(clickedDateTime).add(1, 'hour').format("HH:mm");
                        setPresetStartTime(clickedTime);
                        setPresetEndTime(endTime);
                        setSelectedEvent('');
                    }}
                    eventClick={info => onEventClick(info)}
                    height="auto"
                    contentHeight="auto"
                />
            </div>
            {isShow &&
                <AddEventModal modelRef={modelRef} t={t} clickedDate={clickedDate} selectedEvent={selectedEvent}
                    oncloseModal={() => {
                        closeModal();
                        setPresetStartTime('');
                        setPresetEndTime('');
                    }}
                    onSave={(newEvent: any) => {
                        setCalendarEvents(prev => [...prev, newEvent]);
                        setSelectedEvent('')
                        setPresetStartTime('');
                        setPresetEndTime('');
                    }}
                    presetStartTime={presetStartTime}
                    presetEndTime={presetEndTime}
                    setTimesheetEvents={setTimesheetEvents}
                />
            }

            {isOpen && popoverPosition && popoverEvent && !currentView.startsWith('list') && (
                <ExternalEventPopover
                    position={popoverPosition}
                    event={popoverEvent}
                    IsAdd={permissions?.IsAdd}
                    onClose={() => {
                        setPopoverEvent(null);
                        setPopoverPosition(null);
                        setIsOpen(false);
                    }}
                    onSave={(newEvent: any) => {
                        if (newEvent.extendedProps?.type === 'internal') {
                            setCalendarEvents(prev => [...prev, newEvent]);
                        } else {
                            setSelectedEvent(newEvent);
                            setClickedDate(new Date(newEvent.start));
                            setisShow(true);
                        }

                        setPopoverEvent(null);
                        setPopoverPosition(null);
                        setIsOpen(false);
                    }}
                />
            )}

            {isOpenCalendarSettings && (
                <CalendarSettings t={t} onClose={closeSettingsModal} />
            )}

            {isModalOpen && (
                <InternalEventPopover
                    position={internalPopoverPosition}
                    event={selectedEvent}
                    presetStartTime={presetStartTime}
                    presetEndTime={presetEndTime}
                    IsEdit={permissions?.IsEdit}
                    IsDelete={permissions?.IsDelete}
                    onClose={() => {
                        setInternalPopoverPosition(null);
                        setIsModalOpen(false);
                        // setSelectedEvent('');
                    }}
                    onSave={(newEvent: any) => {
                        if (newEvent.type === 'delete') {
                            setCalendarEvents(prev => prev.filter(e => e.id !== newEvent.id));
                        }
                        setIsModalOpen(false);
                    }}
                    onOpenEditModal={(event: any) => {
                        setSelectedEvent(event);
                        setInternalPopoverPosition(null);
                        setIsModalOpen(false);
                        setIsAddEvent(true);
                    }}
                    onOpenAddEventModal={(event: any) => {
                        setSelectedEvent(event);
                        setInternalPopoverPosition(null);
                        setIsModalOpen(false);
                        setisShow(true);
                    }}
                />
            )}

            {isAddEvent && (
                <UpdateInternalEvent modelRef={modelRef} t={t} clickedDate={clickedDate} showTimesheet={showTimesheet} selectedEvent={selectedEvent} IsAdd={permissions?.IsAdd}
                    presetStartTime={presetStartTime}
                    presetEndTime={presetEndTime}
                    oncloseModal={() => {
                        setSelectedEvent('');
                        closeAddEventModal();
                    }}
                />
            )}

            {showLegends && legendsButtonRef && (
                <EventLegendsPopup
                    GoogleColorCode={GoogleColorCode}
                    OutlookColorCode={OutlookColorCode}
                    showTimesheet={showTimesheet}
                    showTimeoff={showTimeoff}
                    onClose={() => setShowLegends(false)}
                    buttonRef={legendsButtonRef}
                />
            )}

            <ReactTooltip
                id="tooltip-TimeEntry"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 999999,
                    maxWidth: 220,
                    whiteSpace: 'normal'
                }}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable={true}
            />

            <ReactTooltip
                id="event-data-tooltip"
                style={{
                    fontSize: 12,
                    fontWeight: 'normal',
                    padding: 8,
                    borderRadius: 6,
                    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
                    backgroundColor: 'black',
                    color: 'white',
                    zIndex: 999999,
                    maxWidth: 220,
                }}
                place="top"
                delayShow={200}
                offset={7}
                noArrow={false}
            />
        </>
    )
}

export default Calendar